// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"1049e2e9","453":"bd93d95e"}[chunkId] + ".chunk.js";
};